import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { style: {"text-align":"center"} }
const _hoisted_2 = {
  key: 0,
  class: "p-mb-3"
}
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = { class: "p-mt-3" }
const _hoisted_5 = { class: "p-float-label" }
const _hoisted_6 = { class: "p-mt-3" }
const _hoisted_7 = { class: "p-float-label" }
const _hoisted_8 = {
  key: 0,
  style: {"margin-top":"0","margin-bottom":"40px"}
}
const _hoisted_9 = { class: "p-float-label terms-and-conditions" }
const _hoisted_10 = {
  class: "pointerevents no-tooltip",
  for: "termsandconditions"
}
const _hoisted_11 = {
  href: "/datenschutz",
  target: "_blank"
}
const _hoisted_12 = { class: "call-to-action mobile-bottom-nav p-mt-0" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right" }, null, -1)

import { ref, onMounted, computed, getCurrentInstance, nextTick } from 'vue';
    import { helpers, requiredIf } from '@vuelidate/validators';
    import { useI18n } from "vue-i18n";
    import { createJobTitleService } from '@/services/jobTitleService';
    import { createSkillService } from '@/services/skillService';
    import { createProfileService } from "@/services/profileService";
    import { createSignupService } from "@/services/signupService";
    import { useToast } from "primevue/usetoast";
    import { Skill } from "@/models/Skill";
    import { JobTitle } from "@/models/JobTitle";
    import Documents from '@/components/profile/Documents.vue'
    import TechSkillSelector from '@/components/TechSkillSelector.vue'
    import useVuelidate from '@vuelidate/core';
    import { UserCircleIcon } from "@heroicons/vue/outline";
    import Timeline from "@/registration/tech/wizard/Timeline.vue";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'StepOne',
  props: ["candidate", "isDirectSignUp", "step", "hideTermsOfCondition" ],
  emits: ['next'],
  setup(__props, { emit: __emit }) {

    const app = getCurrentInstance();
    const props = __props;
    const emit = __emit;
    const user = ref(props.candidate);
    const step = ref(props.step);
    const hideTermsOfCondition = ref(props.hideTermsOfCondition);
    const { t } = useI18n();
    const jobTitles = ref<JobTitle>([]);
    const skills = ref<Skill>([]);
    const isDirectSignUp = ref(props.isDirectSignUp);
    const languageSkills = [1, 2, 3, 4].map(x => { return { id: x, name: t('profile.form.languageskill.' + x) }});
    const selectedJobTitles = computed({
        get: () => jobTitles.value.filter(x => user.value.jobTitles.find(j => j.id == x.id)),
        set: (value) => { user.value.jobTitles = value }})


    const rules = computed(() => {
        return {
            jobTitles: { },
            keySkills: { },
            germanLevel: { },
            englishLevel: { },
            acceptTermsAndConditions: {
                requiredIf: helpers.withMessage(t("validate.required.error"), requiredIf(() => {
                    return isDirectSignUp.value && !hideTermsOfCondition.value;
                }))
            }
        }
    });
    const v$ = useVuelidate(rules, user);
    const submitted = ref(false);
    const validate = () => {
        submitted.value = true;
        v$.value.$touch();
        return v$.value.$error;
    }
    function compare(a, b) {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    }
    const availableJobTitlesOptions = ref([]);
    const fetchJobTitles = async () => {
        const service = await createJobTitleService();
        const response = await service.getByBrand(1);
        jobTitles.value = response.data;
        availableJobTitlesOptions.value = [...jobTitles.value];
        availableJobTitlesOptions.value.forEach(option => {
            option.name = t(option.name)
        });
        availableJobTitlesOptions.value.sort(compare);
    }
    const fetchSkills = async () => {
        const service = await createSkillService();
        const response = await service.getByBrand(1);
        skills.value = response.data;
    }

    const toaster = useToast();
    const cvUploaded = async () => {
        const service = !isDirectSignUp.value ? await createProfileService(app) : await createSignupService();
        const req = !isDirectSignUp.value ? await service.getLatestCV() : service.getLatestCV(user.value.encryptedId);
        if (req) {
            user.value.latestCV = req;
        } else {
            toaster.add({
                severity: "error",
                summary: "Es gab ein Problem beim Aktualisieren der Ansicht",
                detail: "",
                life: 3000,
            });
        }
    }

    const next = async () => {
        if (validate())
            return;
        emit("next");
    }

    // workaround for enums, which have the int value of 0
    const seniorityChanged = () => {
        nextTick(() => {
            {
                document.getElementById("seniority_label")?.classList.add("p-inputwrapper-filled")
            }
        });
    }

    onMounted(async () => {
        await fetchJobTitles();
        await fetchSkills();
        if (user.value.seniorityLevel == 0)
            seniorityChanged();
    });


return (_ctx: any,_cache: any) => {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(UserCircleIcon), {
        style: {"width":"60px"},
        class: "mobile-hide"
      }),
      _createVNode(Timeline, { step: step.value }, null, 8, ["step"]),
      (isDirectSignUp.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(t)("registration.tech.direct.welcome", { fullName: user.value.fullName })), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_MultiSelect, {
          "data-cy": "tech-reg-jobtitles",
          modelValue: selectedJobTitles.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedJobTitles).value = $event)),
          filter: true,
          autoFilterFocus: true,
          filterIcon: "pi pi-search",
          class: _normalizeClass({ 'p-invalid': _unref(v$).jobTitles.$error && submitted.value }),
          selectionLimit: 1,
          options: availableJobTitlesOptions.value,
          optionLabel: "name"
        }, null, 8, ["modelValue", "class", "options"]),
        _createElementVNode("label", null, _toDisplayString(_unref(t)("current.job.title")), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).jobTitles.$errors, (error, index) => {
        return (_openBlock(), _createElementBlock("small", {
          class: "p-error",
          key: index
        }, _toDisplayString(_unref(t)(error.$message)), 1))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, [
        _createVNode(TechSkillSelector, {
          "data-cy": "tech-reg-skills",
          modelValue: _unref(v$).keySkills.$model,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).keySkills.$model) = $event)),
          invalid: _unref(v$).keySkills.$error && submitted.value
        }, null, 8, ["modelValue", "invalid"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).keySkills.$errors, (error, index) => {
        return (_openBlock(), _createElementBlock("small", {
          class: "p-error",
          key: index
        }, _toDisplayString(_unref(t)(error.$message)), 1))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", _hoisted_7, [
        _createVNode(_component_Dropdown, {
          "data-cy": "tech-reg-german-level",
          id: "germanLevel",
          modelValue: _unref(v$).germanLevel.$model,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).germanLevel.$model) = $event)),
          options: _unref(languageSkills).filter(x => x.id > 1),
          class: _normalizeClass({ 'p-invalid': _unref(v$).germanLevel.$error && submitted.value }),
          optionValue: "id",
          optionLabel: "name"
        }, null, 8, ["modelValue", "options", "class"]),
        _createElementVNode("label", null, _toDisplayString(_unref(t)("profile.form.languageskill.german")), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).germanLevel.$errors, (error, index) => {
        return (_openBlock(), _createElementBlock("small", {
          class: "p-error",
          key: index
        }, _toDisplayString(_unref(t)(error.$message)), 1))
      }), 128))
    ]),
    _createVNode(Documents, {
      "data-cy": "tech-reg-cv-upload",
      candidate: user.value,
      showButtons: false,
      disableValidation: true,
      currentBrandId: 1,
      isDirectSignUp: isDirectSignUp.value,
      hideConsent: true,
      showCvIsMandatoryMessage: false,
      onCvUploaded: cvUploaded
    }, null, 8, ["candidate", "isDirectSignUp"]),
    (isDirectSignUp.value && !hideTermsOfCondition.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, [
            _createVNode(_component_Checkbox, {
              id: "acceptTermsAndConditions",
              "data-cy": "termsAndConditionsCheckbox",
              modelValue: _unref(v$).acceptTermsAndConditions.$model,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).acceptTermsAndConditions.$model) = $event)),
              binary: true,
              class: _normalizeClass({'p-invalid':_unref(v$).acceptTermsAndConditions.$error})
            }, null, 8, ["modelValue", "class"]),
            _createElementVNode("label", _hoisted_10, [
              _createTextVNode(_toDisplayString(_unref(t)("registration.data.policy.label1")) + " ", 1),
              _createElementVNode("a", _hoisted_11, _toDisplayString(_unref(t)("privacy.policy")), 1),
              _createTextVNode(_toDisplayString(_unref(t)("registration.data.policy.label2")), 1)
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).acceptTermsAndConditions.$errors, (error, index) => {
            return (_openBlock(), _createElementBlock("small", {
              key: index,
              class: "p-error p-mt-4"
            }, _toDisplayString(_unref(t)("registration.data.policy.please.accept")), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_Button, {
        "data-cy": "tech-reg-button-next",
        class: "button-secondary button-next p-pr-3",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (next()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("continue")) + " ", 1),
          _hoisted_13
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})